import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { initPush } from './services/push';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import Teachers from './pages/Teachers';
import Classes from './pages/Classes';
import Subjects from './pages/Subjects';
import Attendance from './pages/Attendance';
import Grades from './pages/Grades';
import TimetableBuilder from './pages/TimetableBuilder';
import MyRequests from './pages/MyRequests';
import Announcements from './pages/Announcements';
import Users from './pages/Users';
import AuthCallback from './pages/AuthCallback';
import Requests from './pages/Requests';
import LeaveRequests from './pages/LeaveRequests';
import Procurement from './pages/Procurement';
import Warehouse from './pages/Warehouse';
import Branch from './pages/Branch';
import About from './pages/About';
import NewRequest from './pages/NewRequest';
import Enrollment from './pages/Enrollment';
import Chat from './pages/Chat';
import Analytics from './pages/Analytics';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  useEffect(() => { if (user) initPush().catch(() => {}); }, [user]);
  if (user) return children;
  // E-poçtdakı linkə basan istifadəçi giriş etməyibsə, getmək istədiyi ünvanı
  // saxlayırıq — girişdən sonra panel yerinə həmin sənəd açılsın.
  const hara = location.pathname + location.search;
  if (hara && hara !== '/') {
    try { sessionStorage.setItem('ems_hedef', hara); } catch {}
  }
  return <Navigate to="/login" />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="students" element={<Students />} />
        <Route path="teachers" element={<Teachers />} />
        <Route path="classes" element={<Classes />} />
        <Route path="subjects" element={<Subjects />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="grades" element={<Grades />} />
        <Route path="timetable-builder" element={<TimetableBuilder />} />
        <Route path="announcements" element={<Announcements />} />
        <Route path="users" element={<Users />} />
        <Route path="requests" element={<Requests />} />
        <Route path="requests/new" element={<NewRequest />} />
        <Route path="chat" element={<Chat />} />
        <Route path="my-requests" element={<MyRequests />} />
        <Route path="leave" element={<LeaveRequests />} />
        <Route path="procurement" element={<Procurement />} />
        <Route path="warehouse" element={<Warehouse />} />
        {/* Xankəndi ayrıca menyu bəndi deyil — Şöbələr bölməsində kampus
            seçimi ilə açılır. Səhifə ünvanla açıla bilsin deyə saxlanılır. */}
        <Route path="xankendi" element={<Branch code="KH" />} />
        <Route path="about" element={<About />} />
        <Route path="enrollment" element={<Enrollment />} />
        <Route path="analytics" element={<Analytics />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}
